export default __webpack_public_path__ + "static/media/english-to-finnish-screenshot-03.57145683.png";